import { createStyles } from '@mantine/core';
import { Button } from '@repo/foundations';
import { useSuspenseFeatureAccess } from '../../api/hooks/workspace/useSuspenseFeatureAccess';
import { closeAllModals, openModal } from '../ModalManager';
import AddAutomationModal from './AddAutomationModal';

const useStyles = createStyles({
	modalContent: {
		overflow: 'hidden',
		padding: 0,
	},
});

function AddAutomationButton() {
	const { classes } = useStyles();
	const { automationsAccess } = useSuspenseFeatureAccess();

	if (!automationsAccess) {
		return null;
	}

	const handleOnClick = async () => {
		openModal({
			variant: 'default',
			title: 'New automation',
			children: <AddAutomationModal onClose={() => closeAllModals()} />,
			lockScroll: true,
			size: 640,
			padding: 0,
			classNames: {
				body: classes.modalContent,
			},
		});
	};

	return (
		<Button onClick={handleOnClick} variant="primary">
			Create automation
		</Button>
	);
}

export default AddAutomationButton;
